import React, { Component } from 'react';
import { Segment, Icon, Button, Label, Header } from 'semantic-ui-react';
import Papa from 'papaparse';

class SysadminUserUploadUserFlatFile extends Component {
    onChange(e) {
        let files = e.target.files;
        let file = files[0];
        Papa.parse(file, {
            header: false,
            skipEmptyLines: true,
            complete: (results, file) => {
                console.log("Parsing complete:", results, file);
                this.props.processNewFlatFileData(file, results.data.slice(1));
            },
            error: (error, file) => {
                console.log(error, file);
            }
        });
    }
    render() {
        return (
            <>
                <Header as='h3' attached='top'>Upload Users CSV</Header>
                <Segment attached padded>
                    <Button as='div' labelPosition='right' onClick={() => this.input.click()}>
                        <Button icon title="Add users CSV file">
                            <Icon name="file"/>
                        </Button>
                        <Label as='a' basic pointing='left'>
                            Select CSV File
                        </Label>
                    </Button>

                    <input
                        ref={element => this.input = element}
                        hidden
                        onChange={(e)=>this.onChange(e)}
                        type="file"
                    />
                </Segment>
            </>
        );
    }
}

export default SysadminUserUploadUserFlatFile;
